export const TICKET_CATEGORIES = [
  { value: 'feedback', label: 'Feedback' },
  { value: 'bug', label: 'Bug report' },
  { value: 'enhancement', label: 'Enhancement' },
  { value: 'question', label: 'Question' },
  { value: 'billing', label: 'Billing' },
  { value: 'other', label: 'Other' },
];

export const TICKET_PRIORITIES = [
  { value: 'low', label: 'Low' },
  { value: 'normal', label: 'Normal' },
  { value: 'high', label: 'High' },
  { value: 'urgent', label: 'Urgent' },
];

export const TICKET_STATUSES = [
  { value: 'open', label: 'Open' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'waiting_customer', label: 'Waiting on you' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'closed', label: 'Closed' },
];

export const SUPPORT_EMOJIS = [
  '😀', '😊', '🙂', '😉', '😍', '🤔', '😅', '😢', '😮', '🙏', '👍', '👎', '👏', '🎉', '🔥', '✅', '❌', '⚠️', '💡', '🚀', '📝', '🐛', '💬', '❤️', '⭐',
];

export function categoryLabel(value) {
  return TICKET_CATEGORIES.find((c) => c.value === value)?.label || value;
}

export function priorityLabel(value) {
  return TICKET_PRIORITIES.find((p) => p.value === value)?.label || value;
}

export function statusLabel(value) {
  return TICKET_STATUSES.find((s) => s.value === value)?.label || value;
}

export function formatTicketDate(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}

export function parseSupportBody(body) {
  if (!body) return { format: 'quill', html: '' };
  if (typeof body === 'object') {
    if (body.format === 'quill') return body;
    if (body.blocks) return { format: 'editorjs', blocks: body.blocks };
  }
  try {
    const parsed = JSON.parse(body);
    if (parsed?.format === 'quill') return parsed;
    if (parsed?.blocks) return { format: 'editorjs', blocks: parsed.blocks };
  } catch {
    if (typeof body === 'string' && body.includes('<')) {
      return { format: 'quill', html: body };
    }
  }
  return {
    format: 'quill',
    html: `<p>${String(body).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')}</p>`,
  };
}

export function stringifySupportBody(data) {
  if (typeof data === 'string') return data;
  if (data?.html != null) {
    return JSON.stringify({ format: 'quill', html: data.html });
  }
  if (data?.blocks) {
    return JSON.stringify(data);
  }
  return JSON.stringify({ format: 'quill', html: '' });
}

export function isSupportBodyEmpty(data) {
  if (!data) return true;
  if (data.html != null) {
    const html = String(data.html);
    const text = html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();
    if (text) return false;
    return !/<(img|video|a)\b/i.test(html);
  }
  if (data.blocks?.length) {
    return !data.blocks.some((b) => {
      const text = String(b.data?.text || '').replace(/<[^>]+>/g, '').trim();
      return text || b.data?.url;
    });
  }
  return true;
}
